export default {
    our_services: "Our services",
    services_text_1: "Our incubator consists of 11 offices of different sizes, a large meeting room, a coffee corner and printing facilities. We have toilet facilities on each floor and two showers on the ground floor.",
    services_text_2: "We provide startups with office space, mentorship, financial and legal advisory services and monthly networking events. Our goal is to help these businesses thrive by providing the support and resources they need to grow.",
    inquire_now: "Inquire now"
}

